<div class="handler">
  @for (status of statusList(); track status) {
    <app-status-badge [nameId]="status" (click)="closePanel.emit(status)" type="task"></app-status-badge>
  }
</div>
